// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__2nb7Z","AppBar":"Home_AppBar__1pdOq","Heading":"Home_Heading__3O-_K","LargeTile":"Home_LargeTile__a5vs5","SmallTile":"Home_SmallTile__2Ceb6"};